<script lang="ts">
  import { ArtAssetType, SaleOrderStatus } from '@do/models';

  import { PurchaseButton } from '@features/purchase/purchase-button';
  import { purchaseConfig } from '@features/purchase/purchase-form';
  import { PurchaseRequest } from '@features/purchase/purchase-request';

  import type { HashDataTemp, SaleOrder } from '../types';
  import Sold from './sold.svelte';

  export let price: number | null = null;
  export let owner: HashDataTemp | undefined = undefined;
  export let tokenId: number | null = null;
  export let date: number | null | undefined = undefined; // ~TODO: EpochTimeStamp is not defined. Maybe some svelte bug @mingwe
  export let formData: purchaseConfig.PurchaseForm;
  export let formAction: string | undefined = undefined;
  export let isSoldOnAuction = false;
  export let saleOrder: SaleOrder | undefined = undefined;
  export let artworkName: string;
  export let artist: string;
  export let artAssetType: ArtAssetType;

  $: isSaleActive =
    saleOrder?.status === SaleOrderStatus.Placed || (saleOrder?.status === SaleOrderStatus.Realized && !owner && !date);
  $: isRealizedOrSoldOnAuction = saleOrder?.status === SaleOrderStatus.Realized || owner || isSoldOnAuction;
</script>

{#if isSaleActive}
  <!-- TODO - improve conditions here when we add auctions -->
  <PurchaseButton {price} {tokenId} {saleOrder} {artworkName} {artist} {artAssetType} />
{:else if isRealizedOrSoldOnAuction}
  <div
    class="border-default-300 hover:border-default-500 dark:bg-alt-dark rounded-lg border px-4 py-4 transition-colors dark:border-transparent"
  >
    <Sold {owner} {price} {date} />
  </div>
{:else}
  <!-- can not buy and not sold status -->
  <PurchaseRequest {formData} {formAction} />
{/if}
